// extracted by mini-css-extract-plugin
export var page = "resourcePage-module--page--tZC9i";
export var pageHeader = "resourcePage-module--pageHeader--suZtJ";
export var metadata = "resourcePage-module--metadata--cJ0kX";
export var author = "resourcePage-module--author--JBzgL";
export var createdAt = "resourcePage-module--createdAt--RhY3I";
export var profileIcon = "resourcePage-module--profileIcon--HC+FX";
export var separator = "resourcePage-module--separator--Sf6t2";
export var pageBoundary = "resourcePage-module--pageBoundary--FFsbn";
export var imgDescription = "resourcePage-module--imgDescription--hCqWI";
export var imageFrame = "resourcePage-module--imageFrame--Em5Hb";
export var eventDate = "resourcePage-module--eventDate--VQUy-";
export var tag = "resourcePage-module--tag--NQD8b";
export var calendarIcon = "resourcePage-module--calendarIcon--08eql";
export var fullContent = "resourcePage-module--fullContent--f-JNA";
export var signUpButton = "resourcePage-module--signUpButton--luusY";
export var topSection = "resourcePage-module--topSection--zt-Fs";